module.exports = [{
      plugin: require('/Users/zcs/Code/zshannon/daily/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/zcs/Code/zshannon/daily/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
